import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
// import { all_routes } from "../../../../Router/all_routes";
import {
  ChevronUp,
  Edit,
  Eye,
  RotateCcw,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../../../core/redux/action";
import Table from "../../../../core/pagination/datatable";
import { Download } from "react-feather";
import Swal from "sweetalert2";
import EditClient from "./EditClient";
import ViewClient from "./ViewClient";
import AddClient from "./AddClient";

const Clients = () => {
  const dataSource = useSelector(
    (state) => state.rootReducer.applicant_tracking_clients_data
  );

  const [viewObj, setViewObj] = useState([]);
  const [editObj, setEditObj] = useState([]);

  const handleDeleteConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Item deleted");
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your item is safe :)", "info");
      }
    });
  };

  const dispatch = useDispatch();
  const data = useSelector((state) => state.rootReducer.toggle_header);
  //   const route = all_routes;

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.length - b.Name.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Company",
      dataIndex: "Company",
      sorter: (a, b) => a.Company.length - b.Company.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Contact No",
      dataIndex: "Phone",
      sorter: (a, b) => a.Phone.length - b.Phone.length,
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a, b) => a.Email.length - b.Email.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Location",
      dataIndex: "Location",
      sorter: (a, b) => a.unit.length - b.unit.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Status",
      dataIndex: "IsActive",
      render: (text) => {
        const status = text?.toLowerCase() === "yes";
        return (
          <div className="d-flex justify-content-center">
            <span className={`badge ${status ? "bg-success" : "bg-danger"}`}>
              {status ? "Active" : "Inactive"}
            </span>
          </div>
        );
      },
      sorter: (a, b) => a.IsActive.length - b.IsActive.length,
    },

    {
      title: "Website",
      dataIndex: "Website",
      sorter: (a, b) => a.Website.length - b.Website.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <>
          <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link
                to="#"
                className="dropdown-item"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightViewReg"
                aria-controls="offcanvasRightViewReg"
                onClick={() => setViewObj(record)}
              >
                <Eye className="info-img" />
                View
              </Link>
            </li>
            <li>
              <Link
                to="edit-sales.html"
                className="dropdown-item"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightEditReg"
                aria-controls="offcanvasRightEditReg"
                onClick={() => setEditObj(record)}
              >
                <Edit className="info-img text-info" />
                Edit
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item mb-0"
                onClick={handleDeleteConfirmation}
              >
                <Trash2 className="info-img text-danger" />
                Delete
              </Link>
            </li>
          </ul>
        </>
      ),
    },
  ];

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill border border-secondary">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-1">88,798</h4>
                    <p>Total Clients</p>
                  </div>
                  <span className="revenue-icon bg-cyan-transparent text-cyan">
                    <i className="fa-solid fa-layer-group fs-16" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill border border-success">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-1">8,878</h4>
                    <p>Active Clients</p>
                  </div>
                  <span className="revenue-icon bg-teal-transparent text-teal">
                    <i className="ti ti-chart-pie fs-16" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill border border-danger">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-1">97</h4>
                    <p>Inactive Clients</p>
                  </div>
                  <span className="revenue-icon bg-orange-transparent text-orange">
                    <i className="ti ti-lifebuoy fs-16" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill border border-info">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-1">98</h4>
                    <p>New Clients</p>
                  </div>
                  <span className="revenue-icon bg-indigo-transparent text-indigo">
                    <i className="ti ti-hash fs-16" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/applicantTracking/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Client List
                  </h4>
                </ol>
              </nav>
              <h6>Manage your Clients here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>

            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightNewClient"
              aria-controls="offcanvasRightNewClient"
              className="btn btn-primary"
            >
              <i className="ti ti-circle-plus me-1"></i>
              New Client
            </Link>
          </div>
          <div className="page-btn import">
            <Link
              to="#"
              className="btn btn-secondary color"
              data-bs-toggle="modal"
              data-bs-target="#view-notes"
            >
              <Download className="feather me-2" />
              Import Clients
            </Link>
          </div>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="dropdown me-2">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Location
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Hyderabad
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Bangalore
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      NewYork
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Germany
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <Table columns={columns} dataSource={dataSource} />
            </div>
          </div>
        </div>
      </div>
      <>
        <ViewClient viewObj={viewObj} />
        <EditClient editObj={editObj} />
        <AddClient />
      </>
    </div>
  );
};

export default Clients;
